module.exports = __webpack_public_path__ + "img/baking-ingredients3.0e7b05ba.jpeg";